import hashCode from './hash-code.js';
import isDefined from './is-defined.js';
import isUndefined from './is-undefined.js';
const KEY = 'key';
const IDENTIFIER = 'identifier';
export default function withKey(data) {
    if (isUndefined(data[KEY])) {
        const asString = JSON.stringify(data);
        const hash = hashCode(asString);
        return {
            ...data,
            [IDENTIFIER]: hash,
            [KEY]: hash,
        };
    }
    if (isDefined(data[KEY])) {
        return {
            ...data,
            [IDENTIFIER]: data[KEY],
        };
    }
    return data;
}
//# sourceMappingURL=with-key.js.map